module.exports = __webpack_public_path__ + "img/bottom opening.0016de78.png";